import {Spinner} from "reactstrap";
import React from "react";

const AuthContent = ({
    counterTime,
    onReset,
    authResendToken,
    loading,
    onClose,
    onSecondaryClick,
}) => {

    const ResendButton = () => counterTime
        ?
        <p className="modal-box--data mb-4 mx-6 modal-box--text-counter">
            Podés reenviarla en {counterTime}
        </p>
        :
        <button
            className="link-btn w-100 mb-4 mx-6"
            onClick={onReset}
        >
            { !!authResendToken ? 'Reenviar' : 'Cerrar'}
        </button>;


    return (
        <>
            <p className="modal-box--data m-4">
                Necesitamos que nos confirmes que sos vos quien está intentando iniciar sesión.
            </p>
            <p className="modal-box--data mb-4 mx-6">
                Te enviamos una <b>notificación</b> a todos tus dispositivos autorizados
            </p>
            <p className="modal-box--data mb-4 mx-6">
                <b>Recordá activar las notificaciones para recibirla</b>
            </p>
            {
                loading ? <Spinner className="spinner-color"/> : <ResendButton/>
            }
            <button className="cta-button w-100 mt-4" onClick={onClose}>Ya autoricé el dispositivo</button>
            <button className="link-btn w-100 mt-4" onClick={onSecondaryClick}>No puedo acceder al dispositivo</button>
        </>
    )
};

export default AuthContent;
